import { render, staticRenderFns } from "./StatsRow.vue?vue&type=template&id=be90f688&"
import script from "./StatsRow.vue?vue&type=script&lang=js&"
export * from "./StatsRow.vue?vue&type=script&lang=js&"
import style0 from "./StatsRow.vue?vue&type=style&index=0&id=be90f688&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports